import { EVENT_ARTIFACT_FIELDS } from '../../fragments/message/event-artifact-fields';
import { gql } from 'apollo-boost';

export const GET_ARTIFACTS = gql`
    query GetArtifacts($data: GetArtifactsInput) {
        getArtifacts(data: $data) {
            cursor
            artifacts {
                ${EVENT_ARTIFACT_FIELDS}
                id
                type
                semanticTypes
                title
                summary
                image
                sourceUrls
                sourceMessages {
                    id
                    title
                    body
                    createdAt
                    image {
                        url
                        thumbnail {
                            sm
                        }
                    }
                }
                metadata {
                    key
                    label
                    value
                }
                sections {
                    id
                    kind
                    title
                    checkable
                    entries {
                        id
                        label
                        text
                        detail
                        quantity
                        unit
                        optional
                        duration
                        mediaRef
                        order
                        emoji
                    }
                }
                viewerState {
                    id
                    status
                    contextTags
                    checkedEntryIds
                    rating
                    completedAt
                }
                createdAt
                updatedAt
            }
        }
    }
`;
